import { Task } from '../tasks/Task.interface';

export const mapWorkflowStatus = (status: string) => {
  switch (status) {
    case 'To Do':
      return 'to-do';
    case 'Draft':
      return 'draft';
    case 'In Review':
      return 'in-review';
    case 'Approved':
      return 'approved';
  }
  return status;
};

export const tasks: Task[] = [
  // {
  //   id: 3,
  //   name: 'SOP-101 Disaster Recovery Plan',
  //   type: TaskType.Document,
  //   status: 'To Do',
  //   created: new Date(),
  //   modified: new Date(),
  //   createdBy: {
  //     id: 1,
  //     firstName: 'John',
  //     lastName: 'Smith',
  //     email: 'jsmith@isbx.com'
  //   },
  //   modifiedBy: {
  //     id: 1,
  //     firstName: 'John',
  //     lastName: 'Smith',
  //     email: 'jsmith@isbx.com'
  //   }
  // },
  // {
  //   id: 2,
  //   name: 'SOP-102 Data Retention Policy',
  //   type: TaskType.Document,
  //   status: 'Draft',
  //   created: new Date(),
  //   modified: new Date(),
  //   assigned: {
  //     id: 1,
  //     firstName: 'John',
  //     lastName: 'Smith',
  //     email: 'jsmith@isbx.com'
  //   },
  //   createdBy: {
  //     id: 1,
  //     firstName: 'John',
  //     lastName: 'Smith',
  //     email: 'jsmith@isbx.com'
  //   },
  //   modifiedBy: {
  //     id: 1,
  //     firstName: 'John',
  //     lastName: 'Smith',
  //     email: 'jsmith@isbx.com'
  //   }
  // },
  // {
  //   id: 1,
  //   name: 'SOP-103 Software Development Lifecycle',
  //   type: TaskType.Document,
  //   status: 'Approved',
  //   created: new Date(),
  //   modified: new Date(),
  //   children: [
  //     {
  //       id: 1004,
  //       name: 'Review SOP-103 Software Development Lifecycle',
  //       type: TaskType.Reviewer,
  //       status: 'Approved',
  //       created: new Date(),
  //       modified: new Date(),
  //       assigned: {
  //         id: 1,
  //         firstName: 'Ashoi',
  //         lastName: 'Patel',
  //         email: 'aptel@sierralabs.com'
  //       },
  //       createdBy: {
  //         id: 1,
  //         firstName: 'John',
  //         lastName: 'Smith',
  //         email: 'jsmith@isbx.com'
  //       },
  //       modifiedBy: {
  //         id: 1,
  //         firstName: 'John',
  //         lastName: 'Smith',
  //         email: 'jsmith@isbx.com'
  //       }
  //     },
  //     {
  //       id: 1005,
  //       name: 'Review SOP-103 Software Development Lifecycle',
  //       type: TaskType.Reviewer,
  //       status: 'Approved',
  //       created: new Date(),
  //       modified: new Date(),
  //       assigned: {
  //         id: 1,
  //         firstName: 'Andy',
  //         lastName: 'Spoone',
  //         email: 'aspoone@sierralabs.com'
  //       },
  //       createdBy: {
  //         id: 1,
  //         firstName: 'John',
  //         lastName: 'Smith',
  //         email: 'jsmith@isbx.com'
  //       },
  //       modifiedBy: {
  //         id: 1,
  //         firstName: 'John',
  //         lastName: 'Smith',
  //         email: 'jsmith@isbx.com'
  //       }
  //     },
  //     {
  //       id: 1006,
  //       name: 'Review SOP-103 Software Development Lifecycle',
  //       type: TaskType.Reviewer,
  //       status: 'Approved',
  //       created: new Date(),
  //       modified: new Date(),
  //       assigned: {
  //         id: 1,
  //         firstName: 'Steve',
  //         lastName: 'Sigler',
  //         email: 'ssigler@sierralabs.com'
  //       },
  //       createdBy: {
  //         id: 1,
  //         firstName: 'John',
  //         lastName: 'Smith',
  //         email: 'jsmith@isbx.com'
  //       },
  //       modifiedBy: {
  //         id: 1,
  //         firstName: 'John',
  //         lastName: 'Smith',
  //         email: 'jsmith@isbx.com'
  //       }
  //     }
  //   ],
  //   createdBy: {
  //     id: 1,
  //     firstName: 'John',
  //     lastName: 'Smith',
  //     email: 'jsmith@isbx.com'
  //   },
  //   modifiedBy: {
  //     id: 1,
  //     firstName: 'John',
  //     lastName: 'Smith',
  //     email: 'jsmith@isbx.com'
  //   }
  // }
];
